<div class="sidebar-container w-24" [ngClass]="{'collapsed': isCollapsed}" style="z-index:0; position: relative;">
  <grid-sidebar [topMenuItems]="sidebarItems" (selectedChildChanged)="navigateTo($event)"></grid-sidebar>

</div>
